export const customerRatingDropdown = () => [
    { id: 'qualified', description: 'Qualified' },
    { id: 'unqualified', description: 'Unqualified' },
];